module.exports = __webpack_public_path__ + "static/media/takeaway-white.e0b1d827.svg";